import { Button, Stack, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { BsTwitch } from 'react-icons/bs';
import { HiCubeTransparent } from 'react-icons/hi';
import { MdAddToPhotos, MdGavel } from 'react-icons/md';
import { useLocation, useNavigate } from 'react-router-dom';
import { FiPackage } from 'react-icons/fi';


const MobileNavigation = ({
  darkMode,
  walletAddress,
  openMenu,
  handleClickTrigger,
  handleOpenModal,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Box
      sx={{
        position: 'fixed',
        zIndex: 30000,
        bottom: 0,
        backgroundColor: `${darkMode ? '#040404' : '#fff2f8'}`,
        left: 0,
        right: 0,
      }}
    >
      <Box pt={1}>
        <Stack
          direction='row'
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box>
            <Button
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 1,
              }}
              onClick={() => navigate('/home')}
              variant='text'
              color='secondary'
            >
              <Typography color='secondary' component='span'>
                <BsTwitch />
              </Typography>
              <Typography
                component='p'
                sx={
                  location.pathname === '/home'
                    ? {
                        borderRadius: '50%',
                        height: '5px',
                        width: '5px',
                        backgroundColor: `${darkMode ? '#ffffff' : '#040708'}`,
                      }
                    : null
                }
              ></Typography>
            </Button>
          </Box>
          <Box>
            <Button
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 1,
              }}
              onClick={() => navigate('/explore?type=all')}
              variant='text'
              color='secondary'
            >
              <Typography color='secondary' component='span'>
                <HiCubeTransparent />
              </Typography>
              <Typography
                component='p'
                sx={
                  location.pathname === '/explore'
                    ? {
                        borderRadius: '50%',
                        height: '5px',
                        width: '5px',
                        backgroundColor: `${darkMode ? '#ffffff' : '#040708'}`,
                      }
                    : null
                }
              ></Typography>
            </Button>
          </Box>
          <Box>
            <Button
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 1,
              }}
              onClick={() => navigate('/auction?type=live')}
              variant='text'
              color='secondary'
            >
              <Typography color='secondary' component='span'>
                <MdGavel />
              </Typography>
              <Typography
                component='p'
                sx={
                  location.pathname === '/auction'
                    ? {
                        borderRadius: '50%',
                        height: '5px',
                        width: '5px',
                        backgroundColor: `${darkMode ? '#ffffff' : '#040708'}`,
                      }
                    : null
                }
              ></Typography>
            </Button>
          </Box>
          <Box>
            <Button
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 1,
              }}
              onClick={() => navigate('/collections')}
              variant='text'
              color='secondary'
            >
              <Typography color='secondary' component='span'>
                <FiPackage />
              </Typography>
              <Typography
                component='p'
                sx={
                  location.pathname === '/collections'
                    ? {
                        borderRadius: '50%',
                        height: '5px',
                        width: '5px',
                        backgroundColor: `${darkMode ? '#ffffff' : '#040708'}`,
                      }
                    : null
                }
              ></Typography>
            </Button>
          </Box>
          <Box>
            <Button
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 1,
              }}
              onClick={() => navigate('/create-asset')}
              variant='text'
              color='secondary'
            >
              <Typography color='secondary' component='span'>
                <MdAddToPhotos />
              </Typography>
              <Typography
                component='p'
                sx={
                  location.pathname === '/create-asset'
                    ? {
                        borderRadius: '50%',
                        height: '5px',
                        width: '5px',
                        backgroundColor: `${darkMode ? '#ffffff' : '#040708'}`,
                      }
                    : null
                }
              ></Typography>
            </Button>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};

export default MobileNavigation;
